import { render, staticRenderFns } from "./social.vue?vue&type=template&id=16bec24a"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
import style0 from "./social.vue?vue&type=style&index=0&id=16bec24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports